export enum UserRoleEnum {
  super_admin = 'super_admin',
  manager = 'manager', // equal to owner
  admin = 'admin',
  owner = 'owner',
  staff = 'staff',
  agent = 'agent',
}
